const TEMPLATE_KEYS = {
  TEMPLATES: 'templates',
};

export default {
  ...TEMPLATE_KEYS,
};
